import { PopupService } from 'src/app/shared/services/popup/popup.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DaliService } from '@dali/tagger-ng8';
import { environment } from 'src/environments/environment';
import * as channelConstant from '../../constants/channel.constants';
import { BUSINESS_CONST } from '../../constants/business.constants';
import { OpEnum } from '../../enums/op.enum';
import { BUSINNESS, CHANNEL, COUNTRY, ENVIRONMENT, PAGEVIEW } from '../../constants/dali.constants';
import { IFirmlyApproved } from '../../interfaces/firmly-approved';
import { CHANNEL as CHANNEL_CONSTANS } from '../../constants/channel.constants';
import { ErrorModel } from '../../models/error.model';
import { PhaseType } from '../../models/navigation/phase-type.model';
import { ProductProcessType } from '../../models/navigation/product-process-type.model';
import { StepType } from '../../models/navigation/step-type.model';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { CaptureService } from '../capture/capture.service';
import { ChannelCommunicatorService } from '../communicator/channel-communicator/channel-communicator.service';
import { FirmlyApprovedService } from '../firmly-approved/firmly-approved.service';
import { HeaderService } from '../header/header.service';
import { ValidationHelperService } from '../helpers/validation-helper.service';
import { ParametersService } from '../parameters/parameters.service';
import { PostValidateService } from '../post-validate/post-validate.service';
import { ProductLoaderService } from '../product-loader/product-loader.service';

import { TaggingService } from '../tagging/tagging.service';
import { OfferModel } from '../../models/offer.model';
import { PreValidateService } from '../pre-validate/pre-validate.service';

/**
 * Definición de la interfaz IFlowType para establecer un modelo del flujo
 *
 * *Defines IFlowType interface to create flow model*
 *
 * @type {interface}
 */
export interface IFlowType {
  /**
   * Definición de la variable name como string, nombre del flujo
   *
   * *Defines name variable as string, flow name*
   *
   * @type {public}
   * @var {string} name
   */
  name: string;

  /**
   * Definición de la variable name como startPhase, fase inicial
   *
   * *Defines startPhase variable as string, initial phase*
   *
   * @type {public}
   * @var {string} startPhase
   */
  startPhase: string;

  /**
   * Definición de la variable totalPhases como number, número total de fases
   *
   * *Defines totalPhases variable as number, total phases*
   *
   * @type {public}
   * @var {number} totalPhases
   */
  totalPhases: number;

  /**
   * Definición de la variable phases como PhaseType[], lista de fases
   *
   * *Defines phases variable as PhaseType[], phases list*
   *
   * @type {public}
   * @var {PhaseType[]} phases
   */
  phases: PhaseType[];
}

@Injectable()

/**
 * Clase utilizada para la navegación de la aplicación
 *
 * *Class used to navigate through the app*
 *
 * @type {class}
 */
export class NavigationService {
  /**
   * Inicializaión de la variable flowStructure como arreglo de ProductProcessType
   *
   * *Set flowStructure variable as ProductProcessType array*
   *
   * @access              private
   * @type                { ProductProcessType[] }
   */
  flowStructure: ProductProcessType[];

  /**
   * Inicializaión de la variable multiproductFlowUpdate como objeto
   *
   * *Set multiproductFlowUpdate variable as object*
   *
   * @access              private
   * @type                {}
   */
  private multiproductFlowUpdate: {};

  /**
   * Inicializaión de la variable currentPhase como PhaseType
   *
   * *Set currentPhase variable as PhaseType*
   *
   * @access              private
   * @type                { PhaseType }
   */
  private currentPhase: PhaseType;

  /**
   * Inicializaión de la variable currentStep como StepType
   *
   * *Set currentStep variable as StepType*
   *
   * @access              private
   * @type                { StepType }
   */
  private currentStep: StepType;

  /**
   * Inicializaión de la variable currentFlow como IFlowType
   *
   * *Set currentFlow variable as IFlowType*
   *
   * @access              private
   * @type                { IFlowType }
   */
  private currentFlow: IFlowType;

  /**
   * Inicializaión de la variable loadExitScreen como boolean
   *
   * *Set loadExitScreen variable as boolean*
   *
   * @access              private
   * @type                { boolean }
   */
  loadExitScreen: boolean;

  /**
   * Inicializaión de la variable loadCustomScreen como boolean
   *
   * *Set loadCustomScreen variable as boolean*
   *
   * @access              private
   * @type                { boolean }
   */
  loadCustomScreen: boolean;

  /**
   * Inicializaión de la variable isGeneralInformationStep como boolean
   *
   * *Set isGeneralInformationStep variable as boolean*
   *
   * @access              private
   * @type                { boolean }
   */
  isGeneralInformationStep: boolean;

  /**
   * Inicializaión de la variable actualStep como boolean
   *
   * *Set actualStep variable as boolean*
   *
   * @access              private
   * @type                { boolean }
   */
  actualStep: string;

  /**
   * Inicializaión de la variable isGeneralInformationStep como boolean
   *
   * *Set isGeneralInformationStep variable as boolean*
   *
   * @access              private
   * @type                { boolean }
   */
  postLogin: boolean;
  /**
   * Inicializaión de la variable cardDuality como boolean
   *
   * *Set cardDuality variable as boolean*
   *
   * @access              public
   * @type                { boolean }
   */
  cardDuality: boolean;

  /**
   * Definición de la variable storedPreviousStep, guarda el nombre de la pantalla anterior
   *
   * *Defines storedPreviousStep variable as object, store the previous step name*
   *
   * @type {private}
   * @var {string} storedPreviousStep
   */
  private storedPreviousStep: any; // [string | undefined]; // string | undefined; //

  /**
   * Variable que almacenará el código de error generado al inicio de los flujos
   * en algún consumo de servicio.
   */
  private codeError: string;

  /**
   * Summary      Constructor of the component.
   *
   * @param {AbreCuentasService}          abreCuentasService          Injectable abreCuentasService service.
   * @param {PostValidateService}         postValidate                Injectable postValidate angular router.
   * @param {ChannelCommunicatorService}  channelCommunicatorService  Injectable channelCommunicatorService service.
   * @param {RequestService}              requestService              Injectable requestService service.
   * @param {ValidationHelperService}     validationHelperService     injectable validationHelper
   * @param {RequestService}              router                      Injectable router service.
   * @param {DaliService}                 daliService                 Injectable dali service
   * @var   {string[]}                    loadedList                  Set loadedLists as empty array
   * @var   {string[]}                    loadedConfigList            Set loadedConfigList as empty array
   * @var   {boolean}                     loadExitScreen              Set loadExitScreen as empty false
   * @var   {boolean}                     loadCustomScreen            Set loadCustomScreen as empty false
   * @var   {boolean}                     isGeneralInformationStep    Set isGeneralInformationStep as empty false
   */
  constructor(
    private abreCuentasService: AbreCuentasService,
    private postValidate: PostValidateService,
    private preValidate: PreValidateService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private router: Router,
    private headerService: HeaderService,
    public validationHelperService: ValidationHelperService,
    private taggingService: TaggingService,
    private daliService: DaliService,
    private _http: HttpClient,
    private productLoaderService: ProductLoaderService,
    private firmlyApprovedService: FirmlyApprovedService,
    private captureService: CaptureService,
    private parametersService: ParametersService,
    private popupService: PopupService,
  ) {
    this.loadExitScreen = false;
    this.loadCustomScreen = false;
    this.isGeneralInformationStep = false;
    this.storedPreviousStep = [];
  }

  /**
   * Inicializa el flujo obtenido del servicio, este va a ser el flujo que va a seguir la aplicación
   *
   * *Set Up flow obtained from the service, this flow will be followed by the app*
   *
   */
  async startFlow(postlogin: boolean) {
    if (this.codeError) {
      console.error(' <<<<<<<<<<<<<<< Error cargando >>>>>>>>>>>>>>>>>>>>');
      this.navigateToGeneralInformation(this.codeError);
    } else {
      console.log('------ startFlow --------');
      await this.loadApplicationFlow(postlogin);
      console.log('Flow: ', this.flowStructure);
      await this.validateCurrentFlow();
      console.log('CurrentFlow: ', this.currentFlow);
      await this.validateCurrentPhase();
      this.navigateTo(this.currentPhase.start);
      console.log('------ Fin startFlow --------');
    }
  }

  /**
   * Función encargada de validar si viene por CE o CN,
   * para así asignar el flow correspondiente; dado que si
   * viene de CE, el usuario selecciona un producto desde el HOME
   */
  private async validateCurrentFlow() {
    let productSelected: any;
    if (this.abreCuentasService.getPostlogin() && !this.popupService.continueWithFirmlyApproved) {
      productSelected = this.abreCuentasService.getproductSelected() ? this.abreCuentasService.getproductSelected().flow : this.flowStructure[0].startFlow;
    } else {
      productSelected = this.flowStructure[0].startFlow;
    }
    console.warn('<<<<<<< Product selected: ', productSelected);
    this.currentFlow = this.flowStructure[0].flows[productSelected];
  }

  /**
   * Función encargada de ajustar la Fase a Iniciar en onboarding.
   */
  private async validateCurrentPhase() {

    this.currentPhase = this.currentFlow.phases[this.currentFlow.startPhase];
    console.log('currentPhase: ', this.currentPhase);
    this.currentPhase.key = this.currentFlow.startPhase;
    this.currentStep = this.currentPhase.steps[this.currentPhase.start];
    console.log(this.currentStep, 'current');
    this.currentStep.key = this.currentPhase.start;

  }

  async sentDataToPCO() {
    await this.captureService.performPco().then(async () => {
      return;
    });
  }

  /* istanbul ignore next */

  /**
   * Cambia de pantalla de acuerdo al flujo inicial
   *
   * *change screen according to initial flow*
   *
   */
  async nextStep(code?: string) {
    console.log('------ nextStep --------');
    console.log(code);
    console.log('currentStep: ', this.currentStep);
    if (this.currentStep && this.currentStep['sendpco']) {
      this.sentDataToPCO();
    }
    if (this.currentStep.savePrevious) {
      if (this.currentStep.next[code || 'default'].indexOf('$phase') >= 0) {
        this.storedPreviousStep[
          this.currentStep.next[code || 'default']
        ] = `$phase/${this.currentPhase.key}/${this.currentStep.key}`;
      } else {
        this.storedPreviousStep[
          `$phase/${this.currentPhase.key}/${this.currentStep.next[code || 'default']
          }`
        ] = `$phase/${this.currentPhase.key}/${this.currentStep.key}`;
      }
    }
    if (this.currentStep.preValidate) {
      const validate = this.currentStep.preValidate[code || 'default'];
      let validateCode = '200';
      if (validate) {
        for (const func of validate) {
          try {
            await this.preValidate
              .switchFunction(func)
              .then((res: string) => {
                validateCode = res;
              });
          } catch (error) {
            console.log(error);
          }
          if (func == 'getPcoAmount') {
            code = validateCode;
          }
          if (validateCode !== '200' && validateCode !== '201' && validateCode !== '202') {
            this.navigateToGeneralInformation(validateCode);
            return;
          }
        }
      }
    }

    if (this.currentStep.postValidate) {
      const validate = this.currentStep.postValidate[code || 'default'];
      console.log('Requiere el siguiente PostValidate >>>> ', validate);

      let validateCode = '200';
      if (validate) {
        for (const func of validate) {
          try {
            await this.postValidate
              .switchFunction(func)
              .then((res: string) => (validateCode = res || validateCode));
          } catch (error) {
            console.log(error);
          }
          if (validateCode === 'secondCall') {
            // this.pageLoadTag(false, ['pv235', '', '', '', '']);
            this.navigateToGeneralInformation('125');
            return;
          }
          if (validateCode !== '200' && validateCode !== '201') {
            this.navigateToGeneralInformation(validateCode);
            return;
          }
        }
      }
      const next_p = !code
        ? this.currentStep.next['default']
        : this.currentStep.next[code];

      this.goToStep(next_p);
      this.productLoaderService.hide();
      return;
    }

    if (code && code !== '200' && code !== '207' && code !== '205' && code !== '202') {
      this.abreCuentasService.caseInfoError(code);
    }
    const next = !code
      ? this.currentStep.next['default']
      : this.currentStep.next[code];
    console.log('next p', next);
    console.log('------ Fin nextStep --------');
    this.goToStep(next);
    this.productLoaderService.hide();
  }

  /**
   * Cambia a la pantalla anterior del flujo
   *
   * *Move back to the previous screen of the flow*
   *
   */
  previousStep(): void {
    let previous = '';
    const currentStep = this.getCurrentStep();
    if (currentStep.previous === 'form-employee') {
      switch (this.abreCuentasService.getOccupationSelected().id) {
        case 1:
          previous = 'form-employee';
          break;
        case 2:
          previous = 'form-employee-independent';
          break;
        case 3:
        case 4:
        case 5:
          previous = 'occupation-tc';
          break;
      }
    } else {
      previous = currentStep.previous;
      if (previous === 'previousControled') {
        const phase = `$phase/${this.currentPhase.key}/${currentStep.key}`;
        previous = this.storedPreviousStep[phase];
      }
    }
    this.goToStep(previous);
  }

  previousStepMulti(code: string): void {
    const currentStep = this.getCurrentStep();
    this.goToStep(currentStep.previous[code]);
  }

  /* istanbul ignore next */
  /**
   * Cambia a una pantalla especifica del flujo
   *
   * *Move to a specific screen from the flow*
   */
  async goToStep(step: string) {
    console.log('------- goToStep ------');
    console.log('step: ', step);
    if (step) {
      if (step === '$exit') {
        this.loadExitScreen = true;
      } else if (step === '$login-app') {
        this.goToLoginPage();
      } else if (step === '$firmlyApproved') {
        console.log('---------redirect to firmlyApproved---------');
        await this.startFlow(this.abreCuentasService.getPostlogin());
      } else if (step.startsWith('$flow')) {
        if (step.split('/').length === 2) {
          this.goToFlowSteps(step.split('/')[1]);
        } else if (step.split('/').length === 3) {
          this.goToFlowSteps(step.split('/')[1], step.split('/')[2]);
        } else if (step.split('/').length === 4) {
          this.goToFlowSteps(
            step.split('/')[1],
            step.split('/')[2],
            step.split('/')[3],
          );
        }
      } else if (step.startsWith('$phase/')) {
        if (step.split('/').length > 2) {
          this.changeToPhase(step.split('/')[1], step.split('/')[2]);
        } else {
          this.changeToPhase(step.split('/')[1]);
        }
      } else if (step === '$customBack') {
        this.loadCustomScreen = true;
      } else {
        const newStep: StepType = this.currentPhase.steps[step];
        if (newStep) {
          this.currentStep = newStep;
          this.currentStep.key = step;
          this.isGeneralInformationStep = false;
          this.navigateTo(step);
        }
      }
    }
    setTimeout(() => {
      this.pageLoadTag();
    }, 500);
    console.log('------- Fin goToStep ------');
  }

  /**
   * Cambia a la pantalla de ingreso
   *
   * *Move back to login screen*
   *
   */
  goToLoginPage(): void {
    this.channelCommunicatorService
      .getImpl()
      .redirectToLoginView()
      .then(_response => {
        return;
      });
  }

  /* istanbul ignore next */
  /**
   * Navega al paso seleccionado de acuerdo al flujo
   *
   * *Navigate to selected step from flow*
   *
   * @param {string} flow
   * @param {string} phase
   * @param {string} step
   */
  // tslint:disable-next-line: no-shadowed-variable
  async goToFlowSteps(flow: string, phase?: string, step?: string) {
    console.log('----------- goToFlowSteps ---------------');
    console.log('Flujo recibido: ', flow);
    console.log('Flujo onboarding: ', this.flowStructure);
    this.currentFlow = this.flowStructure[0].flows[flow];
    console.log('CurrentFlow: ', this.currentFlow);
    let selectedPhase = this.flowStructure[0].flows[flow].startPhase;
    this.abreCuentasService.setPhase(selectedPhase);
    let selectedStep =
      this.flowStructure[0].flows[flow].phases[
        this.flowStructure[0].flows[flow].startPhase
      ].start;
    if (phase && !step) {
      selectedPhase = phase;
    } else if (phase && step) {
      selectedPhase = phase;
      selectedStep = step;
    }
    this.currentPhase = this.flowStructure[0].flows[flow].phases[selectedPhase];
    this.currentPhase.key = phase ? phase : selectedPhase;
    this.currentStep = this.currentPhase.steps[selectedStep];
    this.currentStep.key = selectedStep;
    this.isGeneralInformationStep = false;
    console.log('----------- Fin goToFlowSteps ---------------');
    this.navigateTo(selectedStep);
    return;
  }

  /**
   * Cambia a la pantalla de agencias
   *
   * *Move to AgenciesPage*
   *
   */
  goToAgenciesPage(): void {
    this.channelCommunicatorService
      .getImpl()
      .redirectToAgencyListView()
      .then(_response => {
        return;
      });
  }

  /**
   * Cambia a la pantalla de información general
   *
   * *Move to general infromation screen*
   *
   * @param {string} code
   */
  navigateToGeneralInformation(code: string): void {
    this.actualStep = code;
    this.productLoaderService.hide();
    this.isGeneralInformationStep = true;
    this.abreCuentasService.caseInfoError(code);
    this.navigateTo('general-information');
    this.sendTagByCode(code, this.abreCuentasService.errorInfo);
  }

  /**
   * Se devuelve al paso actual
   *
   * *Return to currente step*
   *
   */
  returnToCurrentStep(): void {
    this.isGeneralInformationStep = false;
    this.navigateTo(this.currentStep.key as string);
  }

  /* istanbul ignore next */
  /**
   * Navega a la fase seleccionada del flujo
   *
   * *Navigate to selected phase from flow*
   *
   */
  async changeToPhase(phase: string, step?: string) {
    this.abreCuentasService.setPhase(phase);
    const nextPhase: PhaseType =
      this.flowStructure[0].flows[this.currentFlow.name].phases[phase];
    if (!nextPhase) {
      return;
    }
    this.currentPhase = nextPhase;
    this.currentPhase.key = phase;
    if (step) {
      this.currentStep = this.currentPhase.steps[step];
      this.currentStep.key = step;
      this.navigateTo(step);
    } else {
      this.currentStep = this.currentPhase.steps[nextPhase.start];
      this.currentStep.key = nextPhase.start;
      this.navigateTo(this.currentPhase.start);
    }
  }

  /**
   * Cambia a la pantalla especifica del flujo
   *
   * *Move to a specific screen of the flow*
   *
   */
  navigateTo(route: string) {
    console.log('navigate', route);

    this.headerService.hide();
    console.log(this.router);
    this.router.navigate([route], { skipLocationChange: true });
    window.scrollTo(0, 0);
  }

  /**
   * Aplica el Formato CamelCase al
   *
   * *Format text to CamelCase*
   *
   * @param {string} text
   *
   */
  camelize(text: string): string {
    const str = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, _index) => {
        return word.toUpperCase();
      })
      .replace(/\s+/g, '');
  }

  /**
   * Obtiene el paso actual
   *
   * *Get current step*
   *
   * @returns {StepType} this.currentStep
   */
  getCurrentStep(): StepType {
    return this.currentStep;
  }

  setCurrentStep(value: any) {
    this.currentStep = value;
  }
  /**
   * Obtiene la phase actual
   *
   * *Get current phase*
   *
   * @returns {PhaseType} this.currentPhase
   */
  getCurrentPhase(): PhaseType {
    return this.currentPhase;
  }

  /**
   * Obtiene el flujo actual
   *
   * *Get current flujo*
   *
   * @returns {IFlowType} this.currentFlow
   */
  getCurrentProductProcess(): IFlowType {
    return this.currentFlow;
  }

  /**
   * Configura los tags de la página para hacer un page view a Google Analytics
   *
   * *Load page tag to make a page view to send to Google Analytics*
   *
   * @param {any} errorName
   * @param {string[]} tagsPageName
   * @param {string []} userPPID
   */
  async pageLoadTag(errorName?: any, tagsPageName?: string[], tagId?: string) {
    const channelId = this.channelCommunicatorService.getChannelId();

    const aplicationId = channelId === '141' ? CHANNEL.superapp : CHANNEL.homeBanking;

    const developmenttype = channelId === CHANNEL_CONSTANS.SUPERAPP.CODE ? 'App' : 'Web';

    if (tagsPageName && tagsPageName.length === 4) {
      this.taggingService.setTagId(
        tagsPageName[0],
        tagsPageName[1],
        tagsPageName[2],
        tagsPageName[3],
      );
    }

    const currentStepEs = this.getCurrentStep().es;
    const stepName = currentStepEs ? currentStepEs : 'Pantalla de error';

    const tagPageId =
      stepName === '$type-product-selected'
        ? this.camelize(this.abreCuentasService.getproductSelected().es)
        : this.camelize(stepName);

    const tagPageName = tagsPageName ? this.taggingService.getTagIdByProduct() : (tagId ? tagId : this.getCurrentStep().tag_name);
    console.log('------ pageLoadTag--------');
    console.log(tagPageName);
    console.log(tagsPageName);
    console.log(this.getCurrentStep().tag_name);

    const loggeado = this.abreCuentasService.getPostlogin() ? ENVIRONMENT.loggeado : ENVIRONMENT.noLoggeado;
    const daliEnv = this.parametersService.getParameter('daliEnvProd');
    try {
      const changes = [
        {
          path: PAGEVIEW.environment.path,
          value: daliEnv ? 'Prod' : 'Dev',
        },
        {
          path: PAGEVIEW.clientIdpf.path,
          value: this.abreCuentasService.getPostlogin() ? this.abreCuentasService.getPPID() : '',
        },
        // {
        //   path: PAGEVIEW.developmenttype.path,
        //   value: developmenttype,
        // },
        {
          path: PAGEVIEW.developmenttype.path,
          value: aplicationId === 'SA' ? 'App' : 'Web',
        },
        {
          path: PAGEVIEW[
            'channel_' + this.channelCommunicatorService.getChannelId()
          ].path,
          value:
            aplicationId === 'SA'
              ? PAGEVIEW.channel_141.value
              : PAGEVIEW.channel_131.value,
        },
        {
          path: PAGEVIEW.useragent.path,
          value: navigator.userAgent,
        },
        {
          path: PAGEVIEW.permissions.path,
          value: this.abreCuentasService.getDevicePermissions() === '' ?
            'NotAvailable' : this.abreCuentasService.getDevicePermissions(),
        },
        {
          path: PAGEVIEW.geolocation.path,
          value: 'NotAvailable',
        },
        {
          path: PAGEVIEW[`${tagPageName}pageName`].path,
          value: aplicationId + ':' + COUNTRY.co + ':' + BUSINNESS.pf + ':' + loggeado
            + ':' + PAGEVIEW[`${tagPageName}pageFamily`].value + ':' + PAGEVIEW[`${tagPageName}subFamily`].value + ':'
            + PAGEVIEW[`${tagPageName}pageAction`].value + ':' + PAGEVIEW[`${tagPageName}pageName`].value,
        },
        {
          path: PAGEVIEW[`${tagPageName}pageFamily`].path,
          value: PAGEVIEW[`${tagPageName}pageFamily`].value,
        },
        {
          path: PAGEVIEW[`${tagPageName}subFamily`].path,
          value: PAGEVIEW[`${tagPageName}subFamily`].value,
        },
        {
          path: PAGEVIEW[`${tagPageName}pageAction`].path,
          value: PAGEVIEW[`${tagPageName}pageAction`].value,
        },
        {
          path: PAGEVIEW[`${tagPageName}pageid`].path,
          value: tagPageId,
        },
      ];
      if (PAGEVIEW[`${tagPageName}transactionName`]) {
        changes.push({
          path: PAGEVIEW[`${tagPageName}transactionName`].path,
          value: PAGEVIEW[`${tagPageName}transactionName`].value,
        });
      }
      if (PAGEVIEW[`${tagPageName}customTransactionSimulationValue`]) {
        changes.push({
          path: PAGEVIEW[`${tagPageName}customTransactionSimulationValue`].path,
          value: this.abreCuentasService.getPcoModel().granted_product.limit_amount.amount.toString(),
        });
      }
      if (PAGEVIEW[`${tagPageName}customTransactionCompletedValue`]) {
        changes.push({
          path: PAGEVIEW[`${tagPageName}customTransactionCompletedValue`].path,
          value: this.abreCuentasService.getPcoModel().granted_product.limit_amount.amount.toString(),
        });
      }
      if (PAGEVIEW[`${tagPageName}transactionProductCategory`]) {
        changes.push({
          path: PAGEVIEW[`${tagPageName}transactionProductCategory`].path,
          value: PAGEVIEW[`${tagPageName}transactionProductCategory`].value,
        });
      }

      if (PAGEVIEW[`${tagPageName}customTransactionStep`]) {
        changes.push({
          path: PAGEVIEW[`${tagPageName}customTransactionStep`].path,
          value: PAGEVIEW[`${tagPageName}customTransactionStep`].value,
        });
      }
      if (PAGEVIEW[`${tagPageName}transactionTransactionStep`]) {
        changes.push({
          path: PAGEVIEW[`${tagPageName}transactionTransactionStep`].path,
          value: PAGEVIEW[`${tagPageName}transactionTransactionStep`].value,
        });
      }
      if (PAGEVIEW[`${tagPageName}customTransactionCheckout`]) {
        changes.push({
          path: PAGEVIEW[`${tagPageName}customTransactionCheckout`].path,
          value: PAGEVIEW[`${tagPageName}customTransactionCheckout`].value,
        });
      }
      if (PAGEVIEW[`${tagPageName}customTransactionComplete`]) {
        changes.push({
          path: PAGEVIEW[`${tagPageName}customTransactionComplete`].path,
          value: PAGEVIEW[`${tagPageName}customTransactionComplete`].value,
        });
      }
      if (PAGEVIEW[`${tagPageName}cardlimitrange`]) {
        changes.push({
          path: PAGEVIEW[`${tagPageName}cardlimitrange`].path,
          value: this.abreCuentasService.getAmountPcoAproved(),
        });
      }
      if (PAGEVIEW[`${tagPageName}status`]) {
        changes.push({
          path: PAGEVIEW[`${tagPageName}status`].path,
          value: this.abreCuentasService.getTransactionStatus() ? this.abreCuentasService.getTransactionStatus() : 'Aprobado',
        });
      }
      /*if (PAGEVIEW[`${tagPageName}cardpartner`]) {
        changes.push({
          path: PAGEVIEW[`${tagPageName}cardpartner`].path,
          value: 'traer de un servicio', // crear variable en servicio, que va a traer esta info
        })
      }*/
      if (PAGEVIEW[`${tagPageName}cardnetwork`]) {
        const {
          /*selectedPayDay,*/
          selectedProduct,
        } = this.abreCuentasService.getPayDayProductSelected();
        changes.push({
          path: PAGEVIEW[`${tagPageName}cardnetwork`].path,
          value: selectedProduct.label,
        });
      }
      if (PAGEVIEW[`${tagPageName}installmentsterm`]) {
        const {
          selectedPayDay,
          /*selectedProduct*/
        } = this.abreCuentasService.getPayDayProductSelected();
        changes.push({
          path: PAGEVIEW[`${tagPageName}installmentsterm`].path,
          value: selectedPayDay.label,
        });
      }
      if (PAGEVIEW[`${tagPageName}cardcategory`]) {
        const cardCategory =
          this.abreCuentasService.getCardTypeModel().tipo_tarjeta;
        changes.push({
          path: PAGEVIEW[`${tagPageName}cardcategory`].path,
          value: cardCategory,
        });
      }
      if (PAGEVIEW[`${tagPageName}transactionProductDetails`]) {
        const occupation = this.abreCuentasService.getOccupationSelected().name;
        changes.push({
          path: PAGEVIEW[`${tagPageName}transactionProductDetails`].path,
          value: occupation,
        });
      }
      if (errorName) {
        changes.push({
          path: PAGEVIEW[`${tagPageName}errorname`].path,
          value: this.camelize(errorName),
        });
      }
      this.daliService.pageLoad(changes);
    } catch (error) {
      console.log(`error en el dali..  ${error}`);
    }
    console.log('------ fin pageLoadTag--------');
  }

  async loadApplicationFlow(postlogin: boolean, url?: any) {
    console.log('------ Load Application Flow --------');
    try {
      const constant = Object.values(channelConstant.CHANNEL);
      const urlConstant: any = constant.find(
        (element: any) =>
          element.CODE === this.channelCommunicatorService.getChannelId(),
      );
      url = postlogin ? urlConstant.POST : urlConstant.PRE;
    } catch (error) {
      console.error({ error: 'no encontro canal', datalle: error });
    }
    await this.setFlowStructure(url);
    console.log('------ Fin Load Application Flow --------');
  }

  async setFlowStructure(url: string) {
    await this._http.get(url).toPromise().then(response => {
      console.log('Channel_AF --- FirmlyApprovedService ---> ', this.firmlyApprovedService);
      let route: string;
      if (!this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
        route = 'aprobados_en_firme_multi';
      } else if (!this.firmlyApprovedService.isEmpty()) {
        route = '';
      } else {
        route = 'abrecuentas_flow_co';
      }
      console.log('Ruta a tomar ---->>> ', route);
      this.flowStructure = this.routeApplicationFlow(route, response['data']);
      console.log('Flujo a seguir >>>> \n', this.flowStructure);
      this.abreCuentasService.setFlowStructure(this.flowStructure);
    });
  }
  // feature-living-integration
  // async pageLoadTag(errorName?: any, tagsPageName?: string[]) {
  //   const channelId = this.channelCommunicatorService.getChannelId();
  //   const aplicationId = channelId === '141' ? CHANNEL.superapp : CHANNEL.homeBanking;
  //   if (tagsPageName && tagsPageName.length === 4) {
  //     this.taggingService.setTagId(
  //       tagsPageName[0],
  //       tagsPageName[1],
  //       tagsPageName[2],
  //       tagsPageName[3],
  //     );
  //   }

  async loadMultiproductFlowUpdate() {
    const url = './assets/resources/multiproduct_flow_update.json';
    await this._http
      .get(url)
      .toPromise()
      .then(dataResponse => {
        this.multiproductFlowUpdate = dataResponse;
        this.abreCuentasService.setMultiproductFlowUpdate(this.multiproductFlowUpdate);
      });
  }

  isCardDuality(): boolean {
    const limits = this.parametersService.getSetting(OpEnum.MULTIPLE_PRODUCT_TC_LIMITS);
    const pcoModel = this.abreCuentasService.getPcoModel();
    const isGrayZone = this.firmlyApprovedService.isEmpty() ? pcoModel.solicitation_status.status_code === 'PCO03' ? true : false : false;
    let ProductsList: any[];
    const self = this.abreCuentasService.getAbreCuentasModel();

    const productType = this.abreCuentasService.getproductSelected().product_type;
    const itemsSelected = this.abreCuentasService.getProductsSelects();
    let aprovedAmount = 0;
    switch (productType) {
      case BUSINESS_CONST.MULTI:
        ProductsList = self.pcoModel.granted_product_multi;
        break;
      default:
        ProductsList = [self.pcoModel.granted_product];
        break;
    }
    ProductsList.forEach((product: { product_type: any; limit_amount: { amount: any; }; }, index: string | number) => {
      if (itemsSelected.length > 0 && itemsSelected[index].product_type === product.product_type) {
        aprovedAmount = product.limit_amount.amount;
      }
      // aprovedAmount = pcoModel.granted_product.limit_amount.amount;

    });

    // const aprovedAmount = pcoModel.granted_product.limit_amount.amount;
    const multipleProduct = aprovedAmount >= limits.minimumAmount ? true : false;
    const isSelectedSeveralfranchises = Array.isArray(this.abreCuentasService.getPayDayProductSelected().selectedProduct);
    this.cardDuality = !isGrayZone && multipleProduct && isSelectedSeveralfranchises;
    this.abreCuentasService.setCarduality(this.cardDuality);

    console.warn('Gray zone ', !isGrayZone);
    console.warn('multiple product ', multipleProduct);
    console.warn('IsSelectedSeveralFranquises ', isSelectedSeveralfranchises);
    console.warn('IS CARD DUALITY ', !isGrayZone && multipleProduct && isSelectedSeveralfranchises);
    return !isGrayZone && multipleProduct && isSelectedSeveralfranchises;
  }

  /**
   * metodos para validar siguiente en flujo multiproducto
   * @param flows flujos seleccionados
   */
  nextMulti(flows: any[]) {
    let codeNext = '200';
    if (!this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
      codeNext = this.nextFirmlyApprovedMulti(flows);
    } else if (this.abreCuentasService.getPostlogin() === true) {
      switch (this.getCurrentStep().key) {
        case 'disbursement-offices-search':
          codeNext = this.flowloan(this.getCurrentStep(), flows);
          break;
        case 'configuration-introduction':
          if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_FREE)) {
            if (!this.abreCuentasService.getClientProduct()) {
              this.getCurrentPhase().steps['opening-savings-account'].previous = 'outlay-selection';
            }
            codeNext = '200';
          } else if (flows.length == 2 && flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC)
            && flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
            this.getCurrentPhase().steps['pay-day-form-tc'].previous = 'configuration-introduction';
            codeNext = '201';
          } else if (this.abreCuentasService.getWasDeleteLoan()) {
            codeNext = this.flowloan(this.getCurrentStep(), flows);
          } else {
            if (!this.abreCuentasService.getClientProduct()) {
              this.getCurrentPhase().steps['opening-savings-account'].previous = 'outlay-selection';
            }
            codeNext = '200';
          }
          break;
        case 'account-selection':
          if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN)) {
            codeNext = this.flowloan(this.getCurrentStep(), flows);
          } else if (flows.length == 2 && flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC) &&
            flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
            codeNext = '202';
          } else if (flows.length == 2 && flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_FREE) &&
            flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
            codeNext = '206';
          } else if (flows.length == 3 && flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)
            && this.abreCuentasService.getAssociateCopyRevolving()) {
            codeNext = '200';
          } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC)) {
            this.getCurrentPhase().steps['pay-day-form-tc'].previous = 'account-selection';
            codeNext = '201';
          } else {
            codeNext = '200';
          }
          break;
        case 'pay-day-form-tc':
          if (this.isCardDuality()) {
            // this.getCurrentPhase().steps['address-config-tc'].previous = 'virtual-card-franchise';
            codeNext = '202';
          } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN)) {
            codeNext = this.flowloan(this.getCurrentStep(), flows);
          } else if (flows.length === 2 && flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
            codeNext = '201';
          } else {

            if (this.abreCuentasService.getClientProduct()) {
              this.getCurrentPhase().steps['address-config-tc'].previous = 'pay-day-form-tc';
              codeNext = '201';
            } else {
              this.getCurrentPhase().steps['receive-card'].previous = 'pay-day-form-tc';
              codeNext = '200';
            }
          }
          break;
        case 'virtual-card-franchise':
          if (flows.length === 2 && flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
            if (this.abreCuentasService.getClientProduct()) {
              this.getCurrentPhase().steps['account-selection-rotativo'].previous = 'virtual-card-franchise';
              codeNext = '206';
            } else {
              this.getCurrentPhase().steps['opening-savings-account'].previous = 'virtual-card-franchise';
              codeNext = '202';
            }
          } else {
            if (this.abreCuentasService.getClientProduct()) {
              this.getCurrentPhase().steps['address-config-tc'].previous = 'virtual-card-franchise';
              codeNext = '200';
            } else {
              this.getCurrentPhase().steps['receive-card'].previous = 'virtual-card-franchise';
              codeNext = '203';
            }

          }
          break;
        case 'address-config-tc':
          if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_FREE)) {
            if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC)) {
              if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
                if (this.abreCuentasService.getcreateProductSelected()) {
                  codeNext = '206';
                } else {
                  codeNext = '200';
                }
              } else {
                // } else if (flows.length === 2 && flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
                //   if(flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC)){
                codeNext = '200';
              }
              // this.getCurrentPhase().steps['account-selection'].previous = 'address-config-tc';
            } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
              codeNext = '203';
            }
          } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN)) {
            codeNext = this.flowloan(this.getCurrentStep(), flows);
          } else if (flows.length === 2 && flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
            if (this.abreCuentasService.getClientProduct()) {
              // this.getCurrentPhase().steps['account-selection-rotativo'].previous = 'address-config-tc';
              codeNext = '206';
            } else {
              // this.getCurrentPhase().steps['opening-savings-account'].previous = 'address-config-tc';
              codeNext = '204';
            }
          } else {
            codeNext = '200';
          }
          break;
        case 'confirm-phone':
          if (flows.find(find => find.flow === BUSINESS_CONST.PRODUCT_TYPE_FREE)) {
            if (flows.find(find => find.flow === BUSINESS_CONST.PRODUCT_TYPE_TC)) {
              this.getCurrentPhase().steps['pay-day-form-tc'].previous = 'confirm-phone';
              codeNext = '202';
            }
          } else {
            this.getCurrentPhase().steps['advisor-code'].previous = 'confirm-phone';
            codeNext = '201';
          }
          break;
        case 'opening-savings-account':
          if (flows.find(find => find.flow === BUSINESS_CONST.PRODUCT_TYPE_LOAN)) {
            codeNext = this.flowloan(this.getCurrentStep(), flows);
          } else if ((flows.length === 2)) {
            if (flows.find(find => find.flow === BUSINESS_CONST.PRODUCT_TYPE_TC)) {
              if (flows.find(find => find.flow === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
                this.getCurrentPhase().steps['receive-card'].previous = 'opening-savings-account';
                codeNext = '201';
              } else {
                this.getCurrentPhase().steps['pay-day-form-tc'].previous = 'opening-savings-account';
                this.getCurrentPhase().steps['opening-savings-account'].previous = 'outlay-selection';
                codeNext = '200';
              }
            } else if (flows.find(find => find.flow != BUSINESS_CONST.PRODUCT_TYPE_TC)) {
              this.getCurrentPhase().steps['receive-card'].previous = 'opening-savings-account';
              codeNext = '201';
            }
          } else {
            this.getCurrentPhase().steps['pay-day-form-tc'].previous = 'opening-savings-account';
            this.getCurrentPhase().steps['opening-savings-account'].previous = 'outlay-selection';
            codeNext = '200';
          }
          break;
        case 'receive-card':
          if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN)) {
            codeNext = this.flowloan(this.getCurrentStep(), flows);
          } else if (this.abreCuentasService.getOfficeStatus()) {
            this.getCurrentPhase().steps['advisor-code'].previous = 'receive-card';
            codeNext = '200';
          } else {
            this.getCurrentPhase().steps['address-config-tc'].previous = 'receive-card';
            codeNext = '201';
          }
          break;
        case 'city-offices-search':
          if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN)) {
            codeNext = this.flowloan(this.getCurrentStep(), flows);
          }
          break;
        case 'outlay-other-bank':
          if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN)) {
            codeNext = this.flowloan(this.getCurrentStep(), flows);
          }
          break;
      }
    } else {
      switch (this.getCurrentStep().key) {
        case 'disbursement-offices-search':
          codeNext = this.flowloan(this.getCurrentStep(), flows);
          break;
        case 'configuration-introduction':
          codeNext = '200';
          this.getCurrentPhase().steps['city-offices-search'].previous = 'configuration-introduction';
          break;
        case 'city-offices-search':
          if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_FREE)) {
            codeNext = '200';
          } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN)) {
            codeNext = this.flowloan(this.getCurrentStep(), flows);
          } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC)) {
            this.getCurrentPhase().steps['pay-day-form-tc'].previous = 'city-offices-search';
            codeNext = '201';
          } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
            codeNext = '200';
          }
          break;
        case 'opening-savings-account':
          if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN)) {
            codeNext = this.flowloan(this.getCurrentStep(), flows);
          } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_FREE)) {
            if (flows.length === 3) {
              codeNext = '200';
            } else if (flows.length === 2 && flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC)) {
              codeNext = '200';
            } else {
              this.getCurrentPhase().steps['receive-card'].previous = 'opening-savings-account';
              codeNext = '201';
            }
          } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
            this.getCurrentPhase().steps['receive-card'].previous = 'opening-savings-account';
            codeNext = '201';
          }
          break;
        case 'pay-day-form-tc':
          if (this.isCardDuality()) {
            codeNext = '202';
          } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN)) {
            codeNext = this.flowloan(this.getCurrentStep(), flows);
          } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_FREE)) {
            this.getCurrentPhase().steps['receive-card'].previous = 'pay-day-form-tc';
            codeNext = '204';
          } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
            this.getCurrentPhase().steps['opening-savings-account'].previous = 'pay-day-form-tc';
            codeNext = '200';
          }
          break;
        case 'address-config-tc':
          if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN)) {
            codeNext = this.flowloan(this.getCurrentStep(), flows);
          } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC) || flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_FREE)) {
            codeNext = '200';
          } else {
            codeNext = '201';
          }
          break;
        case 'virtual-card-franchise':
          if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_FREE)) {
            this.getCurrentPhase().steps['receive-card'].previous = 'virtual-card-franchise';
            this.getCurrentPhase().steps['address-config-tc'].previous = 'receive-card';
            codeNext = '201';
          } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
            this.getCurrentPhase().steps['opening-savings-account'].previous = 'virtual-card-franchise';
            codeNext = '202';
          } else {
            this.getCurrentPhase().steps['address-config-tc'].previous = 'virtual-card-franchise';
            codeNext = '200';
          }
          break;
        case 'confirm-phone':
          // this.getCurrentPhase().steps['advisor-code'].previous = 'confirm-phone';
          codeNext = '201';
          break;
        case 'receive-card':
          if (this.abreCuentasService.getOfficeStatus()) {
            this.getCurrentPhase().steps['confirm-phone'].previous = 'receive-card';
            codeNext = '200';
          } else {
            this.getCurrentPhase().steps['address-config-tc'].previous = 'receive-card';
            codeNext = '201';
          }
          break;
        case 'outlay-other-bank':
          if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN)) {
            codeNext = this.flowloan(this.getCurrentStep(), flows);
          }
          break;
        default:
          break;
      }
    }
    return codeNext;
  }

  nextFirmlyApprovedMulti(productsSelect: OfferModel[]) {
    const productsType = {
      ORD: productsSelect.find(product => product.product === BUSINESS_CONST.PRODUCT_CODE_FREE),
      TCR: productsSelect.find(product => product.product === BUSINESS_CONST.PRODUCT_CODE_TCR),
      CRP: productsSelect.find(product => product.product === BUSINESS_CONST.PRODUCT_CODE_CRP),
    };
    const codeNext = {
      'default': () => channelConstant.CODE_NAVIGATION.CODE_200,
      'configuration-introduction': () => {
        if (productsSelect.length === 2
          && productsType[BUSINESS_CONST.PRODUCT_CODE_TCR]
          && productsType[BUSINESS_CONST.PRODUCT_CODE_CRP]) {
          return channelConstant.CODE_NAVIGATION.CODE_201;
        } else {
          return channelConstant.CODE_NAVIGATION.CODE_200;
        }
      },
      'account-selection': () => {
        if (productsSelect.length === 2 &&
          productsType[BUSINESS_CONST.PRODUCT_CODE_TCR] &&
          productsType[BUSINESS_CONST.PRODUCT_CODE_CRP]) {
          return channelConstant.CODE_NAVIGATION.CODE_202;
        } else if (productsSelect.length === 2 &&
          productsType[BUSINESS_CONST.PRODUCT_CODE_FREE] &&
          productsType[BUSINESS_CONST.PRODUCT_CODE_CRP]) {
          return channelConstant.CODE_NAVIGATION.CODE_206;
        } else if (productsSelect.length === 3 &&
          productsType[BUSINESS_CONST.PRODUCT_CODE_CRP] &&
          this.abreCuentasService.getAssociateCopyRevolving()) {
          return channelConstant.CODE_NAVIGATION.CODE_200;
        } else if (productsType[BUSINESS_CONST.PRODUCT_CODE_TCR]) {
          return channelConstant.CODE_NAVIGATION.CODE_201;
        } else {
          return channelConstant.CODE_NAVIGATION.CODE_200;
        }
      },
      'pay-day-form-tc': () => {
        if (this.isCardDuality()) {
          return channelConstant.CODE_NAVIGATION.CODE_202;
        } else if ((productsSelect.length === 2 && productsType[BUSINESS_CONST.PRODUCT_CODE_CRP])
          || this.abreCuentasService.getClientProduct()) {
          return channelConstant.CODE_NAVIGATION.CODE_201;
        } else {
          return channelConstant.CODE_NAVIGATION.CODE_200;
        }
      },
      'virtual-card-franchise': () => {
        if (productsSelect.length === 2 && productsType[BUSINESS_CONST.PRODUCT_CODE_CRP] && !this.abreCuentasService.getClientProduct()) {
          return channelConstant.CODE_NAVIGATION.CODE_202;
        } else {
          return channelConstant.CODE_NAVIGATION.CODE_200;
        }
      },
      'address-config-tc': () => {
        if (productsSelect.length === 3 && this.abreCuentasService.getcreateProductSelected()
          || (productsSelect.length === 2
            && productsType[BUSINESS_CONST.PRODUCT_CODE_CRP]
            && productsType[BUSINESS_CONST.PRODUCT_CODE_FREE]
            && this.abreCuentasService.getClientProduct())) {
          return channelConstant.CODE_NAVIGATION.CODE_203;
        } else if (productsSelect.length === 2
          && productsType[BUSINESS_CONST.PRODUCT_CODE_CRP]
          && productsType[BUSINESS_CONST.PRODUCT_CODE_TCR]
          && !this.abreCuentasService.getClientProduct()) {
          return channelConstant.CODE_NAVIGATION.CODE_204;
        } else if (productsSelect.length === 2
          && productsType[BUSINESS_CONST.PRODUCT_CODE_CRP]
          && productsType[BUSINESS_CONST.PRODUCT_CODE_TCR]) {
          return channelConstant.CODE_NAVIGATION.CODE_206;
        } else if (productsSelect.length === 2
          && productsType[BUSINESS_CONST.PRODUCT_CODE_CRP]) {
          return channelConstant.CODE_NAVIGATION.CODE_204;
        } else {
          return channelConstant.CODE_NAVIGATION.CODE_200;
        }
      },
      'confirm-phone': () => {
        if (productsSelect.length === 2
          && productsType[BUSINESS_CONST.PRODUCT_CODE_FREE]
          && productsType[BUSINESS_CONST.PRODUCT_CODE_TCR]) {
          return channelConstant.CODE_NAVIGATION.CODE_202;
        } else {
          return channelConstant.CODE_NAVIGATION.CODE_201;
        }
      },
      'opening-savings-account': () => {
        if (productsSelect.length === 2
          && ((productsType[BUSINESS_CONST.PRODUCT_CODE_TCR]
            && productsType[BUSINESS_CONST.PRODUCT_CODE_CRP])
            || !productsType[BUSINESS_CONST.PRODUCT_CODE_TCR])) {
          return channelConstant.CODE_NAVIGATION.CODE_201;
        } else {
          return channelConstant.CODE_NAVIGATION.CODE_200;
        }
      },
      'receive-card': () => {
        if (this.abreCuentasService.getOfficeStatus()) {
          return channelConstant.CODE_NAVIGATION.CODE_200;
        } else {
          return channelConstant.CODE_NAVIGATION.CODE_201;
        }
      },
    };
    const currentStepKey = this.getCurrentStep().key || 'default';
    return codeNext[currentStepKey]
      ? codeNext[currentStepKey]()
      : codeNext.default();
  }

  productLoanIsGranted() {
    const productsGranted = this.abreCuentasService.getPcoModel().granted_product_multi;
    const granteds = productsGranted.filter(i => i.product_type === 'loan');
    return granteds.length > 0;
  }

  flowloan(currentStep, flows) {
    let code;
    switch (currentStep.key) {
      case 'disbursement-offices-search':
        if (this.abreCuentasService.getPassScreenCity() !== channelConstant.navCode[1] || !this.productLoanIsGranted()) {
          if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC)) {
            code = channelConstant.navCode[201];
          } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
            code = this.abreCuentasService.getClientProduct() ? channelConstant.navCode[208] : channelConstant.navCode[204];
          }
        } else {
          code = channelConstant.navCode[207];
        }
        break;
      case 'city-offices-search':
        if (this.abreCuentasService.getPassScreenCity() !== channelConstant.navCode[1] || !this.productLoanIsGranted()) {
          if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC)) {
            code = channelConstant.navCode[201];
          } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
            code = this.abreCuentasService.getClientProduct() ? channelConstant.navCode[208] : channelConstant.navCode[204];
          }
        } else {
          code = channelConstant.navCode[207];
        }
        break;
      case 'address-config-tc':
        if (flows.length === 3 && this.abreCuentasService.getOutlaySelection() !== BUSINESS_CONST.ITAU) {
          code = this.abreCuentasService.getClientProduct() ? channelConstant.navCode[206] : channelConstant.navCode[205];
        } else if (this.abreCuentasService.getOutlaySelection() === BUSINESS_CONST.ITAU) {
          if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) &&
            this.abreCuentasService.getPostlogin() === true &&
            this.abreCuentasService.getcreateProductSelected()) {
            code = channelConstant.navCode[206];
          } else if (this.abreCuentasService.getcreateProductSelected()) {
            code = channelConstant.navCode[201];
          } else {
            code = channelConstant.navCode[204];
          }
        } else if (
          this.abreCuentasService.getOutlaySelection() === BUSINESS_CONST.CHEQUE ||
          this.abreCuentasService.getOutlaySelection() === BUSINESS_CONST.OTRO_BANCO
        ) {
          code = channelConstant.navCode[203];
        }
        break;
      case 'pay-day-form-tc':
        code = channelConstant.navCode[201];
        break;
      case 'outlay-other-bank':
        if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC)) {
          code = channelConstant.navCode[201];
        } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
          code = this.abreCuentasService.getClientProduct() ? channelConstant.navCode[208] : channelConstant.navCode[204];
        }
        break;
      case 'opening-savings-account':
        if (flows.length === 3) {
          if (
            this.abreCuentasService.getOutlaySelection() === BUSINESS_CONST.ITAU &&
            flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC)
          ) {
            code = channelConstant.navCode[200];
          } else {
            code = channelConstant.navCode[203];
          }
        } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC)) {
          code = channelConstant.navCode[200];
        } else {
          code = channelConstant.navCode[203];
        }
        break;
      case 'account-selection':
        if (flows.length === 3) {
          if (this.abreCuentasService.getOutlaySelection() === BUSINESS_CONST.ITAU) {
            code = channelConstant.navCode[201];
          } else if (this.abreCuentasService.getOutlaySelection() === BUSINESS_CONST.CHEQUE) {
            code = channelConstant.navCode[200];
          }
        } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
          code = channelConstant.navCode[206];
        } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC)) {
          code = channelConstant.navCode[201];
        } else {
          code = channelConstant.navCode[200];
        }
        break;
      case 'receive-card':
        if (flows.length === 3) {
          if (this.abreCuentasService.getOfficeStatus()) {
            code = this.officeSelection();
          } else {
            code = channelConstant.navCode[201];
          }
        } else if (this.abreCuentasService.getOfficeStatus()) {
          code = channelConstant.navCode[200];
        } else {
          code = channelConstant.navCode[201];
        }
        break;
      case 'configuration-introduction':
        if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC)) {
          code = channelConstant.navCode[201];
        } else if (flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
          code = this.abreCuentasService.getClientProduct() ? channelConstant.navCode[206] : channelConstant.navCode[205];
        }
        break;
      default:
        code = channelConstant.navCode[200];
        break;
    }
    return code;
  }

  officeSelection() {
    if (this.abreCuentasService.getOutlaySelection() !== BUSINESS_CONST.ITAU) {
      return this.abreCuentasService.getClientProduct() ? channelConstant.navCode[205] : channelConstant.navCode[204];
    } else {
      return channelConstant.navCode[206];
    }
  }

  sendTagByCode(code: string, error?: any) {
    switch (code) {
      case '132':
        this.pageLoadTag(error ? error.title : undefined, undefined, this.abreCuentasService.getPostlogin() ? 'pv468' : 'pv461');
        break;
      case '131':
        this.pageLoadTag(error ? error.title : undefined, undefined, this.abreCuentasService.getPostlogin() ? 'pv469' : 'pv462');
        break;
      case '141':
        this.pageLoadTag(undefined, undefined, 'pv466');
        break;
    }
  }

  private routeApplicationFlow(route: string, applicationFlow: any): any {
    const flowApp = {
      aprobados_en_firme: applicationFlow => applicationFlow.aprobados_en_firme,  // tslint:disable-line
      aprobados_en_firme_multi: applicationFlow => applicationFlow.aprobados_en_firme_multi,  // tslint:disable-line
      default: applicationFlow => applicationFlow.abrecuentas_flow_co,  // tslint:disable-line
    };
    return flowApp[route] ? flowApp[route](applicationFlow) : flowApp.default(applicationFlow);
  }

  getPhase(item: string, phase: string) {
    return this.flowStructure[0].flows[item].phases[phase];
  }

  setCodeError(code: string) {
    this.codeError = code;
  }

  getCodeError() {
    return this.codeError;
  }

}
